export const environment = {
	production: true,
	firebase: {
		apiKey: "AIzaSyBixWjw1STkfEQTB6CSC-Fk4Avs8aM4y0Q",
		authDomain: "quiz.curiosityroad.com",
		databaseURL: "https://quiz42.firebaseio.com",
		projectId: "quiz42",
		storageBucket: "quiz42.appspot.com",
		messagingSenderId: "306212312127",
		appId: "1:306212312127:web:bd3535190f98226e3d948a",
		measurementId: "G-LS6L03BQYQ",
		vapidKey: "BJByHBY7DJC-aEbAThCl51Br4DWPc1IVcStY3-Om-BVq7vWf-OljyWZS-Q7GXOL0o6cRy2KbIWl_gskZsoHvMEI",
	},
	curiosity: "https://gospring.ai",
	playerUrl: "https://gospring.ai",
	creatorDomain: "https://creator.gospring.ai",
	// creatorDomain: "https://creator.curiosityroad.com",
	apiUrl:"https://us-central1-quiz42.cloudfunctions.net",
	algolia: {
		appId: 'KB5N82M005',
		searchApiKey: 'f34786ac9e9040ca5a6936ce25154248'
	},
	razPayId: '',
	currencyExchangeKey: '767d5e21821caf68c51be149',
	internalAccount:"ebGl6wWxjERc6cHt0fDQ",
	adminUser:['rQa4mmVfzkQttxRZjTeXXgj8AUG3','mhDw63iW0ehPyex4Xt0fgBxYmbs2','q4uE0ajpCWahFlnd0NNxWmaP7eE2','8FNIFYTpS8NSwlyqxmMpfBG3oKh1','gNLCdkDEoZUriwfqn6CIYTnjnL23', 'tD3e5XtAjcYqkTcyl4D6WfILLmx2'],
	gtm_id: "UA-215323944-1"
};
